


















































import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
import S3Mixin from '@/components/mixins/s3';
import { CvDesignTemplateSample } from '@/../gen';

export default mixins(E2EMixin, S3Mixin).extend({
  props: {
    cvDesignTemplateSamples: {
      type: Array as () => CvDesignTemplateSample[],
      required: true,
    },
    // v-model
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        innerCvDesignTemplateSelected: this.value,
      },
    };
  },
  watch: {
    'formData.innerCvDesignTemplateSelected'(val: number) {
      this.$emit('input', val);
    },
  },
});
